import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectCurrentImage = (state: ReduxApplicationState) =>
  state.productImagesCarousel.currentImage;

export const selectNavigatedBy = (state: ReduxApplicationState) =>
  state.productImagesCarousel.navigatedBy;
